/** A BaseMaterial3D's blend mode and the colour blend attachment Godot programs for each. */
import { enumNamesByValue } from '../../classdb/enumNames.js';
/**
 * `BaseMaterial3D::BlendMode` (`scene/resources/material.h:227-233`), as the integers a `.tscn`
 * stores for `blend_mode`. The default is MIX (`material.h:601`).
 */
export const BlendMode = {
    MIX: 0,
    ADD: 1,
    SUB: 2,
    MUL: 3,
    PREMULT_ALPHA: 4,
};
export const BASE_MATERIAL_3D_BLEND_MODE_NAMES = enumNamesByValue(BlendMode);
/**
 * `blend_mode_to_blend_attachment` (`servers/rendering/renderer_rd/storage_rd/material_storage.cpp:651-716`),
 * verbatim. Every mode enables blending, and the alpha channel gets its own factors in all five.
 */
export const GODOT_BLEND_ATTACHMENTS = {
    [BlendMode.MIX]: {
        colorOp: 'add',
        srcColor: 'src-alpha',
        dstColor: 'one-minus-src-alpha',
        alphaOp: 'add',
        srcAlpha: 'one',
        dstAlpha: 'one-minus-src-alpha',
    },
    [BlendMode.ADD]: {
        colorOp: 'add',
        srcColor: 'src-alpha',
        dstColor: 'one',
        alphaOp: 'add',
        srcAlpha: 'src-alpha',
        dstAlpha: 'one',
    },
    [BlendMode.SUB]: {
        colorOp: 'reverse-subtract',
        srcColor: 'src-alpha',
        dstColor: 'one',
        alphaOp: 'reverse-subtract',
        srcAlpha: 'src-alpha',
        dstAlpha: 'one',
    },
    [BlendMode.MUL]: {
        colorOp: 'add',
        srcColor: 'dst-color',
        dstColor: 'zero',
        alphaOp: 'add',
        srcAlpha: 'dst-alpha',
        dstAlpha: 'zero',
    },
    [BlendMode.PREMULT_ALPHA]: {
        colorOp: 'add',
        srcColor: 'one',
        dstColor: 'one-minus-src-alpha',
        alphaOp: 'add',
        srcAlpha: 'one',
        dstAlpha: 'one-minus-src-alpha',
    },
};
/**
 * `BLEND_MODE_ALPHA_TO_COVERAGE` (`material_storage.cpp:691-698`), which any alpha antialiasing mode
 * puts in place of the material's own blend mode (`scene_shader_forward_clustered.cpp:237-241`).
 */
export const ALPHA_TO_COVERAGE_ATTACHMENT = {
    colorOp: 'add',
    srcColor: 'src-alpha',
    dstColor: 'one-minus-src-alpha',
    alphaOp: 'add',
    srcAlpha: 'one',
    dstAlpha: 'zero',
};
//# sourceMappingURL=blendMode.js.map